
import React from 'react';

export const TypingIndicator = () => (
  <div className="flex items-center space-x-2">
    <span className="animate-bounce text-xl">😊</span>
    <span className="animate-bounce text-xl" style={{animationDelay: '0.2s'}}>😊</span>
    <span className="animate-bounce text-xl" style={{animationDelay: '0.4s'}}>😊</span>
  </div>
);

export const BackgroundEffects = () => {
  const titleEmojis = [];
  const floatingEmojis = ['😊', '🎉', '🎈', '🌈'];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Dynamic gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-amber-400/20 via-transparent to-transparent" />
      
      {/* Title area effects */}
      <div className="absolute top-0 left-0 w-full h-16 flex items-center justify-center">
        {titleEmojis.map((emoji, index) => (
          <span
            key={`title-${index}`}
            className="absolute text-2xl animate-[emoji-float-rotate_4s_ease-in-out_infinite]"
            style={{
              left: `${20 + (index * 20)}%`,
              animationDelay: `${index * 0.3}s`,
              filter: 'drop-shadow(0 0 5px rgba(251, 191, 36, 0.5))'
            }}
          >
            {emoji}
          </span>
        ))}
      </div>

      {/* Floating background emojis */}
      <div className="absolute inset-0">
        {floatingEmojis.map((emoji, index) => (
          <span
            key={`float-${index}`}
            className="absolute text-3xl opacity-30"
            style={{
              left: `${Math.random() * 80 + 10}%`,
              top: `${Math.random() * 50 + 10}%`,
              animation: `emoji-float-rotate ${3 + index}s ease-in-out infinite`,
              animationDelay: `${index * 0.5}s`
            }}
          >
            {emoji}
          </span>
        ))}
      </div>

      {/* Shine effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/10 to-transparent animate-[emoji-header-shine_3s_ease-in-out_infinite]" />
    </div>
  );
};